import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';
import pkg from '../package.json';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './i18n';
import App from './App.tsx';
import config from './config/index.ts';

Sentry.init({
  dsn: config.sentry_dsn,
  environment: config.env,
  release: `medicus-meetings@${pkg.version}`,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration()
  ],
  tracePropagationTargets: [
    /^https:\/\/stg-gateway\.medicusunion\.me\//,
    /^https:\/\/api\.medicusunion\.com\//,
    /^https:\/\/stg-api-meeting\.medicusunion\.me\//,
    /^https:\/\/api-meeting\.medicusunion\.com\//
  ],
  tracesSampleRate: 0.05,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  enabled: config.env !== 'development',
});

createRoot(document.getElementById('root')!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <App />
);
